import { CLASSIC_COLOR_PACK_ID, type ThemePack } from '@/types/theme-packs.types';

/**
 * resolves the effective campaigns theme for ONE email - suite in this feature means the
 * single email being edited, not a project-wide group, so theme assignment is per-email
 * not on the project
 *
 * falls back to the channel's default theme pack when this email has never had
 * one explicitly assigned, so it never renders without theme
 *
 * does not fall back to the project's own page theme
 */
export function resolveEmailCampaignsThemePack(
  themePacks: ThemePack[] | null | undefined,
  themeColorPackId: number | undefined
): ThemePack | undefined {
  const explicit = themeColorPackId ? themePacks?.find((pack) => pack.color_pack === themeColorPackId) : undefined;
  if (explicit) return explicit;
  return themePacks?.find((pack) => pack.color_pack === CLASSIC_COLOR_PACK_ID) ?? themePacks?.[0] ?? undefined;
}
